export default __webpack_public_path__ + "static/media/forma-predlocheniyi.fab3f79c.pdf";